import { NgModule } from '@angular/core';
import { coreI18nConfig } from '@core/const';
import { CoreDataAccessModule } from '@core/data-access';
import { CoreFeatureModule } from '@core/feature';
import { CoreUtilsModule } from '@core/utils';
import { provideConfig } from '@spartacus/core';

@NgModule({
  providers: [provideConfig(coreI18nConfig)],
  imports: [CoreDataAccessModule, CoreFeatureModule, CoreUtilsModule],
})
export class CoreShellModule {}
